import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const Sidebar = ({ children, className }) => (
	<div className={cx("sidebar", { [className]: className })}>{children}</div>
);

Sidebar.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js